import { render, staticRenderFns } from "./InventoryGlobalFilter.vue?vue&type=template&id=8076af9e&scoped=true&lang=html&"
import script from "./InventoryGlobalFilter.vue?vue&type=script&lang=js&"
export * from "./InventoryGlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8076af9e",
  null
  
)

export default component.exports